export const COMMENTABLE_TYPES = {
  COMMENT: 'Comment',
  POST: 'Post',
  EVENT: 'NetworkEvents::Event',
  USER_EVENT: 'User::Event',
  FORUMS: 'Forums::Discussion',
  NEWS: 'Communication',
};

export const SORT_BY = {
  RECENT: 'recents',
  VOTES: 'votes',
};

export const COMMENTS_PER_PAGE = 5;
